export const getUserMoreRequests = /* GraphQL */ `
    query GetUser($id: ID!) {
        getUser(id: $id) {
            id
            firstName
            lastName
            username
            email
            orgID
            organization {
                id
                name
                shortName
                users {
                    nextToken
                }
                websites {
                    nextToken
                }
                clientLeads
                createdAt
                updatedAt
            }
            cognitoID
            requests(limit: 9999) {
                items {
                    id
                    status
                    userID
                    ticketID
                    redboothID
                    title
                    websiteID
                    urgent
                    dueDate
                    orgID
                    createdAt
                    updatedAt
                }
                nextToken
            }
            createdAt
            updatedAt
        }
    }
`;